import { useState } from 'react'
import { useNavigate } from 'react-router'
import { Button, ConfirmDialog, InfoBox } from '@biznomi/ui-react'
import { useAuth } from '@/lib/auth/store'
import { useOrg } from '@/lib/useOrg'
import { logout } from '@/lib/api/auth'
import { clearOrgCode } from '@/lib/org'

export default function Settings() {
  const navigate = useNavigate()
  const user = useAuth((s) => s.user)
  const clearAuth = useAuth((s) => s.clearAuth)
  const { data: org } = useOrg()
  const [confirmOrgChange, setConfirmOrgChange] = useState(false)

  async function signOut() {
    await logout().catch(() => undefined)
    clearAuth()
    navigate('/login', { replace: true })
  }

  function changeOrg() {
    clearOrgCode()
    clearAuth()
    window.location.href = '/login'
  }

  return (
    <div className="space-y-5">
      <h1 className="text-xl font-bold">설정</h1>

      <dl className="divide-y divide-slate-100 overflow-hidden rounded-card bg-card">
        {[
          ['이름', user?.name],
          ['소속', user?.departmentName ?? '미지정'],
          ['사번', user?.employeeNumber ?? '—'],
          ['회사', org?.name],
        ].map(([k, v]) => (
          <div key={k} className="flex items-center justify-between px-4 py-3.5">
            <dt className="text-sm text-slate-500">{k}</dt>
            <dd className="text-sm font-medium">{v ?? '—'}</dd>
          </div>
        ))}
      </dl>

      <InfoBox tone="info">
        출퇴근은 NFC 태그에 폰을 대는 것으로만 기록됩니다. 기록된 시각은 수정되지 않으며, 정정이 필요하면
        수기 등록으로 요청하세요.
      </InfoBox>

      <div className="space-y-2">
        <Button variant="secondary" size="lg" className="w-full" onClick={() => setConfirmOrgChange(true)}>
          회사 변경
        </Button>
        <Button variant="ghost" size="default" className="w-full" onClick={signOut}>
          로그아웃
        </Button>
      </div>

      {/* 회사 변경은 세션까지 지우므로 확인을 받는다 */}
      <ConfirmDialog
        open={confirmOrgChange}
        onOpenChange={setConfirmOrgChange}
        title="회사를 변경할까요?"
        message={`현재 로그인이 해제되고 회사 코드 입력 화면으로 돌아갑니다.\n저장된 출퇴근 기록은 지워지지 않습니다.`}
        confirmText="변경"
        onConfirm={changeOrg}
      />
    </div>
  )
}
